import { Player } from '@lottiefiles/react-lottie-player'
import { FC } from 'react'
import loadIndicator from 'assets/images/loading_indicator.json'

export const LoadingIndicator: FC = () => {
  return (
    <Player
      autoplay
      loop
      src={loadIndicator}
      style={{ height: '300px', width: '300px' }}
    />
  )
}

